import { useContext } from "react";
import {
  __RouterContext,
  RouteComponentProps,
  StaticContext
} from "react-router";
import H from "history";

// FIXME:  use official API when https://github.com/ReactTraining/react-router/pull/6453 merged

export function useRouter<
  Params extends { [K in keyof Params]?: string } = {},
  C extends StaticContext = StaticContext,
  S = H.LocationState
>() {
  return useContext(__RouterContext) as RouteComponentProps<Params, C, S>;
}
